export default __webpack_public_path__ + "static/insight-dark-bd04fa46a52b86ce90f190d9c1f7a2c0.png";